import Page404 from "../pages/page404/index.vue";
const routes = [
  {
    name: "pcIndex",
    path: "/",
    meta: { index: 1, title: "首页" },
    component: (resolve) => require(["@/pages/pc/index.vue"], resolve),
  },
  {
    name: "levelIntroduce",
    path: "/levelIntroduce",
    meta: { index: 1, title: "等级管理" },
    component: (resolve) =>
      require(["@/pages/level/levelIntroduce.vue"], resolve),
  },

  {
    name: "buyMember",
    path: "/buyMember",
    meta: { index: 1, title: "VIP会员" },
    component: (resolve) => require(["@/pages/level/buyMember.vue"], resolve),
  },
  {
    name: "profitMain",
    path: "/profitMain",
    meta: { index: 1, title: "收益管理" },
    component: (resolve) => require(["@/pages/profit/profitMain.vue"], resolve),
  },
  {
    name: "hasProfit",
    path: "/hasProfit",
    meta: { index: 1, title: "提现" },
    component: (resolve) => require(["@/pages/profit/hasProfit.vue"], resolve),
  },
  {
    name: "exchangeCoin",
    path: "/exchangeCoin",
    meta: { index: 1, title: "兑换" },
    component: (resolve) =>
      require(["@/pages/profit/exchangeCoin.vue"], resolve),
  },
  {
    name: "giftProfit",
    path: "/giftProfit",
    meta: { index: 1, title: "礼物记录" },
    component: (resolve) => require(["@/pages/profit/giftProfit.vue"], resolve),
  },
  {
    name: "weekProfit",
    path: "/weekProfit",
    meta: { index: 1, title: "收益记录" },
    component: (resolve) => require(["@/pages/profit/weekProfit.vue"], resolve),
  },
  {
    name: "otayoniiInfo",
    path: "/otayoniiInfo",
    meta: { index: 1, title: "礼物金豆明细" },
    component: (resolve) =>
      require(["@/pages/profit/otayoniiInfo.vue"], resolve),
  },
  {
    name: "addInfo",
    path: "/addInfo",
    meta: { index: 1, title: "信息完善" },
    component: (resolve) => require(["@/pages/profit/addInfo.vue"], resolve),
  },
  {
    name: "familyMain",
    path: "/familyMain",
    meta: { index: 1, title: "家族管理" },
    component: (resolve) => require(["@/pages/family/familyMain.vue"], resolve),
  },
  {
    name: "salaryMain",
    path: "/salaryMain",
    meta: { index: 1, title: "主播数据" },
    component: (resolve) => require(["@/pages/family/salaryMain.vue"], resolve),
  },
  {
    name: "grant",
    path: "/grant",
    meta: { index: 1, title: "工资发放" },
    component: (resolve) => require(["@/pages/family/grant.vue"], resolve),
  },
  {
    name: "openLiveRate",
    path: "/openLiveRate",
    meta: { index: 1, title: "开播率" },
    component: (resolve) =>
      require(["@/pages/family/openLiveRate.vue"], resolve),
  },
  {
    name: "payroll",
    path: "/payroll",
    meta: { index: 1, title: "金豆分配" },
    component: (resolve) => require(["@/pages/family/payroll.vue"], resolve),
  },
  {
    name: "vjSalary",
    path: "/vjSalary",
    meta: { index: 1, title: "主播薪水" },
    component: (resolve) => require(["@/pages/family/vjSalary.vue"], resolve),
  },
  {
    name: "micTime",
    path: "/micTime",
    meta: { index: 1, title: "主播麦时" },
    component: (resolve) => require(["@/pages/family/micTime.vue"], resolve),
  },
  {
    name: "anchroOtayonii",
    path: "/anchroOtayonii",
    meta: { index: 1, title: "主播金豆明细" },
    component: (resolve) =>
      require(["@/pages/family/anchroOtayonii.vue"], resolve),
  },
  {
    name: "anchorExchange",
    path: "/anchorExchange",
    meta: { index: 1, title: "主播提现明细" },
    component: (resolve) =>
      require(["@/pages/family/anchorExchange.vue"], resolve),
  },
  {
    name: "anchorCenter",
    path: "/anchorCenter",
    meta: { index: 1, title: "主播中心" },
    component: (resolve) =>
      require(["@/pages/familyManagement/anchorCenter.vue"], resolve),
  },
  // {
  //   name: "familyManagement",
  //   path: "/familyManagement",
  //   meta: { index: 1, title: "家族管理" },
  //   component: (resolve) =>
  //     require(["@/pages/familyManagement/index.vue"], resolve),
  // },
  // {
  //   name: "coinExchange",
  //   path: "/coinExchange",
  //   meta: { index: 1, title: "金币兑换" },
  //   component: (resolve) =>
  //     require(["@/pages/familyManagement/coinExchange.vue"], resolve),
  // },

  {
    name: "anchorList2",
    path: "/anchorList2",
    meta: { index: 1, title: "主播列表" },
    component: (resolve) =>
      require(["@/pages/familyManagement/anchorList.vue"], resolve),
  },
  {
    name: "unionManagement",
    path: "/unionManagement",
    meta: { index: 1, title: "工会管理" },
    component: (resolve) =>
      require(["@/pages/familyManagement/unionManagement.vue"], resolve),
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: { index: 1, title: "统计" },
    component: (resolve) =>
      require(["@/pages/familyManagement/statistics.vue"], resolve),
  },
  {
    name: "familyInvitation",
    path: "/familyInvitation",
    meta: { index: 1, title: "家族长邀请" },
    component: (resolve) =>
      require(["@/pages/familyManagement/familyInvitation.vue"], resolve),
  },
  {
    name: "userInvitation",
    path: "/userInvitation",
    meta: { index: 1, title: "用户邀请" },
    component: (resolve) =>
      require(["@/pages/familyManagement/userInvitation.vue"], resolve),
  },
  {
    name: "landingPage",
    path: "/landingPage",
    meta: { index: 1, title: "邀请落地页" },
    component: (resolve) =>
      require(["@/pages/familyManagement/landingPage.vue"], resolve),
  },

  {
    name: "familyInvitationDetail",
    path: "/familyInvitationDetail",
    meta: { index: 1, title: "邀请详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/familyInvitationDetail.vue"], resolve),
  },

  {
    name: "activityRules",
    path: "/activityRules",
    meta: { index: 1, title: "活动规则" },
    component: (resolve) =>
      require(["@/pages/activity/activityRules.vue"], resolve),
  },

  {
    name: "liveDetails",
    path: "/liveDetails",
    meta: { index: 1, title: "直播详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/liveDetails.vue"], resolve),
  },
  {
    name: "liveDetails2",
    path: "/liveDetails2",
    meta: { index: 1, title: "直播详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/liveDetails2.vue"], resolve),
  },
  {
    name: "personalData",
    path: "/personalData",
    meta: { index: 1, title: "个人数据" },
    component: (resolve) =>
      require(["@/pages/familyManagement/personalData.vue"], resolve),
  },
  {
    name: "withdrawal",
    path: "/withdrawal",
    meta: { index: 1, title: "提现" },
    component: (resolve) =>
      require(["@/pages/familyManagement/withdrawal.vue"], resolve),
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: { index: 1, title: "提现" },
    component: (resolve) =>
      require(["@/pages/merchants/withdraw.vue"], resolve),
  },
  {
    name: "bankCardInfo",
    path: "/bankCardInfo",
    meta: { index: 1, title: "银行卡信息" },
    component: (resolve) =>
      require(["@/pages/merchants/bankCardInfo.vue"], resolve),
  },

  {
    name: "withdrawalRecords",
    path: "/withdrawalRecords",
    meta: { index: 1, title: "提现记录" },
    component: (resolve) =>
      require(["@/pages/familyManagement/withdrawalRecords.vue"], resolve),
  },

  {
    name: "accountBalance",
    path: "/accountBalance",
    meta: { index: 1, title: "家族管理" },
    component: (resolve) =>
      require(["@/pages/familyManagement/accountBalance.vue"], resolve),
  },
  {
    name: "unionSettlement",
    path: "/unionSettlement",
    meta: { index: 1, title: "公会入驻" },
    component: (resolve) =>
      require(["@/pages/unionManagement/unionSettlement.vue"], resolve),
  },
  {
    name: "myGuild",
    path: "/myGuild",
    meta: { index: 1, title: "我的公会" },
    component: (resolve) =>
      require(["@/pages/unionManagement/myGuild.vue"], resolve),
  },
  {
    name: "joinGuild",
    path: "/joinGuild",
    meta: { index: 1, title: "加入公会" },
    component: (resolve) =>
      require(["@/pages/unionManagement/joinGuild.vue"], resolve),
  },
  {
    name: "applyJoin",
    path: "/applyJoin",
    meta: { index: 1, title: "申请入驻" },
    component: (resolve) =>
      require(["@/pages/unionManagement/applyJoin.vue"], resolve),
  },

  {
    name: "familyManagement",
    path: "/familyManagement",
    meta: { index: 1, title: "公会管理" },
    component: (resolve) =>
      require(["@/pages/unionManagement/familyManagement.vue"], resolve),
  },

  {
    name: "unionList",
    path: "/unionList",
    meta: { index: 1, title: "我的公会" },
    component: (resolve) =>
      require(["@/pages/unionManagement/unionList.vue"], resolve),
  },

  {
    name: "contactUs",
    path: "/contactUs",
    meta: { index: 1, title: "联系我们" },
    component: (resolve) =>
      require(["@/pages/unionManagement/contactUs.vue"], resolve),
  },
  {
    name: "pcContactUs",
    path: "/pcContactUs",
    meta: { index: 1, title: "联系我们" },
    component: (resolve) => require(["@/pages/pc/pcContactUs.vue"], resolve),
  },
  {
    name: "pcOfficial",
    path: "/pcOfficial",
    meta: { index: 1, title: "官网" },
    component: (resolve) =>
      require(["@/pages/official/official.vue"], resolve),
  },
  {
    name: "voiceHallOnboarding",
    path: "/voiceHallOnboarding",
    meta: { index: 1, title: "语音厅入驻" },
    component: (resolve) =>
      require(["@/pages/unionManagement/voiceHallOnboarding.vue"], resolve),
  },

  {
    name: "anchorEquityLevel",
    path: "/anchorEquityLevel",
    meta: { index: 1, title: "等级权益" },
    component: (resolve) =>
      require(["@/pages/unionManagement/anchorEquityLevel.vue"], resolve),
  },
  {
    name: "userEquityLevel",
    path: "/userEquityLevel",
    meta: { index: 1, title: "等级权益" },
    component: (resolve) =>
      require(["@/pages/unionManagement/userEquityLevel.vue"], resolve),
  },

  {
    name: "anchorData",
    path: "/anchorData",
    meta: { index: 1, title: "主播数据" },
    component: (resolve) => require(["@/pages/anchor/anchorData.vue"], resolve),
  },
  {
    name: "anchorGiftDetails",
    path: "/anchorGiftDetails",
    meta: { index: 1, title: "主播特效明细" },
    component: (resolve) =>
      require(["@/pages/anchor/anchorGiftDetails.vue"], resolve),
  },

  {
    name: "guildData",
    path: "/guildData",
    meta: { index: 1, title: "公会数据" },
    component: (resolve) => require(["@/pages/guild/guildData.vue"], resolve),
  },
  {
    name: "guildGiftDetails",
    path: "/guildGiftDetails",
    meta: { index: 1, title: "公会特效明细" },
    component: (resolve) =>
      require(["@/pages/guild/guildGiftDetails.vue"], resolve),
  },

  {
    name: "knapsackList",
    path: "/knapsackList",
    meta: { index: 1, title: "特效明细" },
    component: (resolve) =>
      require(["@/pages/family/knapsackList.vue"], resolve),
  },
  {
    name: "roomCm",
    path: "/roomCm",
    meta: { index: 1, title: "房间流水" },
    component: (resolve) => require(["@/pages/family/roomCm.vue"], resolve),
  },
  {
    name: "fail",
    path: "/failMain",
    meta: { index: 1, title: "登录失效" },
    component: (resolve) => require(["@/pages/fail/failMain.vue"], resolve),
  },
  {
    name: "index",
    path: "/index",
    meta: { index: 1, title: "下载页" },
    component: (resolve) => require(["@/pages/download/index.vue"], resolve),
  },
  {
    name: "anchorExchanges",
    path: "/anchorExchanges",
    meta: { index: 1, title: "主播赠送" },
    component: (resolve) =>
      require(["@/pages/activity/anchorExchanges.vue"], resolve),
  },
  {
    name: "anchorExchangeList",
    path: "/anchorExchangeList",
    meta: { index: 1, title: "赠送明细" },
    component: (resolve) =>
      require(["@/pages/activity/anchorExchangeList.vue"], resolve),
  },
  {
    name: "agree",
    path: "/agree",
    meta: { index: 1, title: "用户协议" },
    component: (resolve) => require(["@/pages/user/agree.vue"], resolve),
  },
  {
    name: "conceal",
    path: "/conceal",
    meta: { index: 1, title: "隐私政策" },
    component: (resolve) => require(["@/pages/user/conceal.vue"], resolve),
  },
  {
    name: "anchor",
    path: "/anchor",
    meta: { index: 1, title: "主播协议" },
    component: (resolve) => require(["@/pages/user/anchor.vue"], resolve),
  },
  {
    name: "recharge",
    path: "/recharge",
    meta: { index: 1, title: "充值协议" },
    component: (resolve) => require(["@/pages/user/recharge.vue"], resolve),
  },
  {
    name: "intregal",
    path: "/intregal",
    meta: { index: 1, title: "活跃任务" },
    component: (resolve) => require(["@/pages/activity/intregal.vue"], resolve),
  },
  {
    name: "voucherCenter",
    path: "/voucherCenter",
    meta: { index: 1, title: "充值中心" },
    component: (resolve) =>
      require(["@/pages/user/voucherCenter.vue"], resolve),
  },
  {
    name: "goldenEggs",
    path: "/goldenEggs",
    meta: { index: 1, title: "砸金蛋" },
    component: (resolve) =>
      require(["@/pages/gameActivities/goldenEggs.vue"], resolve),
  },
  {
    name: "lucky-wheel",
    path: "/lucky-wheel",
    meta: { index: 1, title: "抽奖大转盘" },
    component: (resolve) =>
      require(["@/pages/gameActivities/lucky-wheel.vue"], resolve),
  },
  {
    name: "paySuccess",
    path: "/paySuccess",
    meta: { index: 1, title: "抽奖大转盘" },
    component: (resolve) => require(["@/pages/user/paySuccess.vue"], resolve),
  },
  {
    name: "firstChange",
    path: "/firstChange",
    meta: { index: 1, title: "首充活动" },
    component: (resolve) =>
      require(["@/pages/activity/firstChange.vue"], resolve),
  },
  {
    name: "contactService",
    path: "/contactService",
    meta: { index: 1, title: "联系客服" },
    component: (resolve) =>
      require(["@/pages/activity/contactService.vue"], resolve),
  },
  {
    name: "millionActivity",
    path: "/millionActivity",
    meta: { index: 1, title: "百万赠送三重奏" },
    component: (resolve) =>
      require(["@/pages/activity/millionActivity.vue"], resolve),
  },
  {
    name: "inFamily",
    path: "/inFamily",
    meta: { index: 1, title: "公会招募" },
    component: (resolve) =>
      require(["@/pages/activity/in_family.vue"], resolve),
  },
  {
    name: "dayFirstCharge",
    path: "/dayFirstCharge",
    meta: { index: 1, title: "每日首充活动" },
    component: (resolve) =>
      require(["@/pages/activity/dayFirstCharge.vue"], resolve),
  },
  {
    name: "51",
    path: "/51",
    meta: { index: 1, title: "热门活动" },
    component: (resolve) => require(["@/pages/activity/51.vue"], resolve),
  },

  {
    name: "invitingActivities",
    path: "/invitingActivities",
    meta: { index: 1, title: "热门活动" },
    component: (resolve) =>
      require(["@/pages/activity/invitingActivities.vue"], resolve),
  },
  {
    name: "certificationMain",
    path: "/certificationMain",
    meta: { index: 1, title: "实名认证" },
    component: (resolve) =>
      require(["@/pages/certification/certificationMain.vue"], resolve),
  },
  {
    name: "certificationResult",
    path: "/certificationResult",
    meta: { index: 1, title: "实名认证结果" },
    component: (resolve) =>
      require(["@/pages/certification/certificationResult.vue"], resolve),
  },
  {
    name: "anchorList",
    path: "/anchorList",
    meta: { index: 1, title: "主播列表" },
    component: (resolve) => require(["@/pages/family/anchorList.vue"], resolve),
  },
  {
    name: "imageGenerationPage",
    path: "/imageGenerationPage",
    meta: { index: 1, title: "活动页" },
    component: (resolve) =>
      require(["@/pages/activity/imageGenerationPage.vue"], resolve),
  },
  {
    name: "imageGenerationPage2",
    path: "/imageGenerationPage2",
    meta: { index: 1, title: "活动页" },
    component: (resolve) =>
      require(["@/pages/activity/imageGenerationPage2.vue"], resolve),
  },
  // {
  //   name: "intregal",
  //   path: "/intregal",
  //   meta: { index: 1, title: "积分活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/intregal/index.vue"], resolve),
  // },
  {
    name: "intregalRule",
    path: "/intregalRule",
    meta: { index: 1, title: "领取规则" },
    component: (resolve) =>
      require(["@/pages/activity/intregal/rule.vue"], resolve),
  },

  {
    name: "convention",
    path: "/convention",
    meta: { index: 1, title: "文明公约" },
    component: (resolve) =>
      require(["@/pages/activity/convention.vue"], resolve),
  },
  {
    name: "newYearsDay",
    path: "/newYearsDay",
    meta: { index: 1, title: "元旦活动" },
    component: (resolve) =>
      require(["@/pages/activity/newYearsDay.vue"], resolve),
  },
  {
    name: "redEnvelopeRain",
    path: "/redEnvelopeRain",
    meta: { index: 1, title: "红包雨活动" },
    component: (resolve) =>
      require(["@/pages/activity/redEnvelopeRain.vue"], resolve),
  },
  {
    name: "zhouXingBang",
    path: "/zhouXingBang",
    meta: { index: 1, title: "周星榜" },
    component: (resolve) =>
      require(["@/pages/activity/zhouXingBang.vue"], resolve),
  },
  {
    name: "zhouXingBangRule",
    path: "/zhouXingBangRule",
    meta: { index: 1, title: "周星榜规则" },
    component: (resolve) =>
      require(["@/pages/activity/zhouXingBangRule.vue"], resolve),
  },

  {
    name: "levelDescription",
    path: "/levelDescription",
    meta: { index: 1, title: "等级说明" },
    component: (resolve) =>
      require(["@/pages/level/levelDescription.vue"], resolve),
  },
  {
    name: "fileUpload",
    path: "/fileUpload",
    meta: { index: 1, title: "文件上传" },
    component: (resolve) => require(["@/pages/pc/fileUpload.vue"], resolve),
  },
  {
    name: "merchantCenter",
    path: "/merchantCenter",
    meta: { index: 1, title: "商户中心" },
    component: (resolve) => require(["@/pages/pc/merchantCenter.vue"], resolve),
  },
  {
    name: "merchantCenterHuiFu",
    path: "/merchantCenterHuiFu",
    meta: { index: 1, title: "汇付商户中心" },
    component: (resolve) =>
      require(["@/pages/pc/merchantCenterHuiFu.vue"], resolve),
  },
  {
    name: "transferpage",
    path: "/transferpage",
    meta: { index: 1, title: "中转页" },
    component: (resolve) => require(["@/pages/h5/transferpage.vue"], resolve),
  },
  {
    name: "contactService",
    path: "/contactService",
    meta: { index: 1, title: "联系客服" },
    component: (resolve) =>
      require(["@/pages/activity/contactService.vue"], resolve),
  },
  {
    name: "giftWall",
    path: "/giftWall",
    meta: { index: 1, title: "礼物墙说明" },
    component: (resolve) => require(["@/pages/activity/giftWall.vue"], resolve),
  },
  {
    name: "nationalDayActivities",
    path: "/blind-box",
    meta: { index: 1, title: "玩法介绍" },
    component: (resolve) =>
      require(["@/pages/activity/blind_box.vue"], resolve),
  },
  {
    name: "nationalDayActivities",
    path: "/nationalDayActivities",
    meta: { index: 1, title: "国庆活动" },
    component: (resolve) =>
      require(["@/pages/activity/nationalDayActivities.vue"], resolve),
  },
  {
    name: "gameRanking",
    path: "/gameRanking",
    meta: { index: 1, title: "gameRanking" },
    component: (resolve) =>
      require(["@/pages/activity/gameRanking.vue"], resolve),
  },
  {
    name: "luckyAnchorRanking",
    path: "/luckyAnchorRanking",
    meta: { index: 1, title: "luckyAnchorRanking" },
    component: (resolve) =>
      require(["@/pages/activity/luckyAnchorRanking.vue"], resolve),
  },
  {
    name: "charmRanking",
    path: "/charmRanking",
    meta: { index: 1, title: "排行榜" },
    component: (resolve) =>
      require(["@/pages/activity/charmRanking.vue"], resolve),
  },
  {
    name: "guildActivity",
    path: "/guildActivity",
    meta: { index: 1, title: "guildActivity" },
    component: (resolve) =>
      require(["@/pages/activity/guildActivity.vue"], resolve),
  },
  {
    name: "sundayActivities",
    path: "/sundayActivities",
    meta: { index: 1, title: "周日活动" },
    component: (resolve) =>
      require(["@/pages/activity/sundayActivities.vue"], resolve),
  },
  {
    name: "userMisconduct",
    path: "/userMisconduct",
    meta: { index: 1, title: "用户违规行为" },
    component: (resolve) =>
      require(["@/pages/activity/userMisconduct.vue"], resolve),
  },

  {
    name: "newExchangeCoin",
    path: "/newExchangeCoin",
    meta: { index: 1, title: "金币兑换" },
    component: (resolve) =>
      require(["@/pages/profit/newExchangeCoin.vue"], resolve),
  },
  {
    name: "standardNetwork",
    path: "/standardNetwork",
    meta: { index: 1, title: "规范网络直播" },
    component: (resolve) =>
      require(["@/pages/activity/standardNetwork.vue"], resolve),
  },

  {
    name: "gameplayIntroduction",
    path: "/gameplayIntroduction",
    meta: { index: 1, title: "大炮玩法介绍" },
    component: (resolve) =>
      require(["@/pages/activity/gameplayIntroduction.vue"], resolve),
  },
  {
    name: "heartbeatGameplay",
    path: "/heartbeatGameplay",
    meta: { index: 1, title: "心动模式玩法介绍" },
    component: (resolve) =>
      require(["@/pages/activity/heartbeatGameplay.vue"], resolve),
  },
  {
    name: "myInvitation",
    path: "/myInvitation",
    meta: { index: 1, title: "我的邀请" },
    component: (resolve) =>
      require(["@/pages/activity/myInvitation.vue"], resolve),
  },

  {
    name: "myGoldenbeans",
    path: "/myGoldenbeans",
    meta: { index: 1, title: "我的金豆" },
    component: (resolve) =>
      require(["@/pages/coinManagement/myGoldenbeans.vue"], resolve),
  },
  {
    name: "coinWithdraw",
    path: "/coinWithdraw",
    component: (resolve) =>
      require(["@/pages/coinManagement/coinWithdraw.vue"], resolve),
  },
  {
    name: "coinExchange",
    path: "/coinExchange",
    component: (resolve) =>
      require(["@/pages/coinManagement/coinExchange.vue"], resolve),
  },
  {
    name: "transactionDetails",
    path: "/transactionDetails",
    component: (resolve) =>
      require(["@/pages/coinManagement/transactionDetails.vue"], resolve),
  },
  {
    name: "coinTransactionRecord",
    path: "/coinTransactionRecord",
    component: (resolve) =>
      require(["@/pages/coinManagement/coinTransactionRecord.vue"], resolve),
  },
  {
    name: "cancelAccount",
    path: "/cancelAccount",
    component: (resolve) =>
      require(["@/pages/unionManagement/cancelAccount.vue"], resolve),
  },
  {
    name: "proxyRecharge",
    path: "/proxyRecharge",
    component: (resolve) =>
      require(["@/pages/proxy/proxyRecharge.vue"], resolve),
  },
  {
    name: "proxyTransfer",
    path: "/proxyTransfer",
    component: (resolve) =>
      require(["@/pages/proxy/proxyTransfer.vue"], resolve),
  },
  {
    name: "proxyLogin",
    path: "/proxyLogin",
    component: (resolve) => require(["@/pages/proxy/proxyLogin.vue"], resolve),
  },
  {
    name: "transferRecord",
    path: "/transferRecord",
    component: (resolve) =>
      require(["@/pages/proxy/transferRecord.vue"], resolve),
  },
  {
    name: "noble",
    path: "/noble",
    component: (resolve) => require(["@/pages/noble/index.vue"], resolve),
  },
  {
    name: "nobleRecharge",
    path: "/nobleRecharge",
    component: (resolve) =>
      require(["@/pages/noble/nobleRecharge.vue"], resolve),
  },

  {
    name: "bd",
    path: "/bd",
    component: (resolve) => require(["@/pages/bd/index.vue"], resolve),
  },
  {
    name: "incomeDetail",
    path: "/incomeDetail",
    component: (resolve) => require(["@/pages/bd/incomeDetail.vue"], resolve),
  },
  {
    name: "inviteFriends",
    path: "/inviteFriends",
    component: (resolve) =>
      require(["@/pages/activity/inviteFriends.vue"], resolve),
  },
  {
    name: "inviteRecord",
    path: "/inviteRecord",
    component: (resolve) =>
      require(["@/pages/activity/inviteRecord.vue"], resolve),
  },
  {
    name: "inviteExplanation",
    path: "/inviteExplanation",
    component: (resolve) =>
      require(["@/pages/activity/inviteExplanation.vue"], resolve),
  },

  {
    path: "/bonusActivity",
    name: "BonusActivity",
    component: () => import("@/pages/activity/bonusActivity.vue"),
  },
  {
    path: "/bonusActivityRule",
    name: "bonusActivityRule",
    component: () => import("@/pages/activity/bonusActivityRule.vue"),
  },

  {
    path: "/bonusPoints",
    name: "bonusPoints",
    component: () => import("@/pages/activity/bonusPoints.vue"),
  },

  {
    path: "/withdrawalRecord",
    name: "withdrawalRecord",
    component: () => import("@/pages/coinManagement/withdrawalRecord.vue"),
  },

  {
    path: "/inviteActivity",
    name: "inviteActivity",
    meta: { index: 1, title: "inviteActivity" },
    component: () => import("@/pages/activity/inviteActivity.vue"),
  },
  {
    path: "/newInviteActivity",
    name: "newInviteActivity",
    meta: { index: 1, title: "newInviteActivity" },
    component: () => import("@/pages/activity/newInviteActivity.vue"),
  },
  {
    name: "newGameRanking",
    path: "/newGameRanking",
    meta: { index: 1, title: "newGameRanking" },
    component: (resolve) =>
      require(["@/pages/activity/newGameRanking.vue"], resolve),
  },
  {
    path: "/giftGoldCoins",
    name: "giftGoldCoins",
    meta: { index: 1, title: "giftGoldCoins" },
    component: () => import("@/pages/activity/giftGoldCoins.vue"),
  },
  {
    path: "/newRedEnvelopeRain",
    name: "newRedEnvelopeRain",
    meta: { index: 1, title: "newRedEnvelopeRain" },
    component: () => import("@/pages/activity/newRedEnvelopeRain.vue"),
  },
  {
    path: "/guildLivestreamActivity",
    name: "guildLivestreamActivity",
    meta: { index: 1, title: "guildLivestreamActivity" },
    component: () => import("@/pages/activity/guildLivestreamActivity.vue"),
  },
  {
    path: "/halfScreenRanking",
    name: "halfScreenRanking",
    meta: { index: 1, title: "halfScreenRanking" },
    component: () => import("@/pages/activity/halfScreenRanking.vue"),
  },
  {
    path: "/decorationShop",
    name: "decorationShop",
    meta: { index: 1, title: "decorationShop" },
    component: () => import("@/pages/shop/index.vue"),
  },
  {
    path: "/myDecoration",
    name: "myDecoration",
    meta: { index: 1, title: "myDecoration" },
    component: () => import("@/pages/shop/myDecoration.vue"),
  },
  {
    path: "/christmasActivity",
    name: "christmasActivity",
    meta: { index: 1, title: "christmasActivity" },
    component: () => import("@/pages/activity/christmasActivity.vue"),
  },
  {
    path: "/luckyStarActivity",
    name: "luckyStarActivity",
    meta: { index: 1, title: "幸运星活动" },
    component: () => import("@/pages/activity/luckyStarActivity.vue"),
  },
  {
    path: "/h5download",
    name: "h5download",
    meta: { index: 1, title: "Rain Live" },
    component: () => import("@/pages/h5/download.vue"),
  },
  {
    path: "/h5Official",
    name: "h5Official",
    meta: { index: 1, title: "官网" },
    component: () => import("@/pages/official/official.vue"),
  },
  {
    path: "/fortuneStarActivity",
    name: "fortuneStarActivity",
    meta: { index: 1, title: "Fortune Star Activity" },
    component: () => import("@/pages/activity/fortuneStarActivity.vue"),
  },

  {
    path: "*",
    component: Page404, //404页面
  },
];
export default routes;
